import * as React from 'react';

import {EmptyStateLarge} from '../empty-states/empty-state-large';

type Props = {
    message: string;
};
export function ErrorState(props: Props) {
    return (
        <EmptyStateLarge
            title='Oh no, something went wrong'
            subtitle={props.message}
            icon={
                <img
                    alt=''
                    style={{width: 240}}
                    // TODO: find a better error image
                    src='/include/images/email-drip/email-sent-inbox-unconfigured_2x.png'
                />
            }
        />
    );
}
